var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAlarmIcAlarmBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 50,
    cy: 73,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 23h4c14.36 0 26 11.64 26 26v21a5 5 0 0 1-5 5H27a5 5 0 0 1-5-5V49c0-14.36 11.64-26 26-26z",
    fill: "#BCADF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAlarmIcAlarmBasic);
export default __webpack_public_path__ + "static/media/icons_alarm_ic_alarm_basic.62980381e52e59329707cf3e9f3e9342.svg";
export { ForwardRef as ReactComponent };